// frontend/src/components/staff/AutoCloseBanner.js
//
// Workforce — TIME-007 §5 Staff post-event banner on /staff/clock.
//
// v1 scope (minimal API-dependency posture per Marcus tech doc §5 — there
// is no dedicated staff-side endpoint in v1, only the admin config + admin
// recent endpoints):
//
// - For `flag_only` behavior: the open shift stays open but
//   `flagged_overlong: true`. We render a banner reading from the existing
//   /workforce/timelogs/me/open response shape that the parent
//   ClockInOutScreen already polls (TIME-004a + TIME-005 pattern). Zero
//   new endpoint.
// - For `auto_close` behavior: the shift was force-closed; the staff is no
//   longer "clocked in" so getOpenShift returns null. Surfacing a "your
//   shift was auto-closed" notice for this case requires a "my recent
//   TimeLogs" or "my last force-closed TimeLog" endpoint that Marcus's v1
//   tech doc does NOT provision. Cross-link to TIME-010 Submit Missing
//   Punch is the recovery path; the banner copy below points there.
//
// Zuri spec §5 acknowledges the banner-endpoint assumption is pending
// Marcus reconciliation. v1 implementation surfaces flag_only directly;
// auto_close case is a future story when an endpoint surfaces.
//
// Component contract: takes `openTimeLog` (TIME-004a/005's existing local
// state) and `onSubmitMissingPunch` (callback to trigger TIME-010 modal
// open from the parent). Renders nothing if openTimeLog is null/undefined
// or if `flagged_overlong` is not true.

import React from "react";
import "./AutoCloseBanner.css";

const AutoCloseBanner = ({ openTimeLog, onSubmitMissingPunch }) => {
  if (!openTimeLog) return null;
  if (!openTimeLog.flagged_overlong) return null;

  return (
    <div
      className="auto-close-banner"
      role="status"
      data-testid="auto-close-banner"
    >
      <div className="auto-close-banner-icon" aria-hidden="true">
        !
      </div>
      <div className="auto-close-banner-body">
        <p className="auto-close-banner-headline">
          Your current shift exceeds the studio&apos;s auto-clock-out threshold.
        </p>
        <p className="auto-close-banner-detail">
          The studio has flagged this shift for review. If you forgot to clock
          out earlier today, submit a missing-punch correction so the timesheet
          reflects the right hours.
        </p>
        {typeof onSubmitMissingPunch === "function" && (
          <button
            type="button"
            className="auto-close-banner-cta"
            onClick={onSubmitMissingPunch}
            data-testid="auto-close-banner-cta"
          >
            Submit Missing Punch
          </button>
        )}
      </div>
    </div>
  );
};

export default AutoCloseBanner;
